// Types for the result object with discriminated union
type Success<T> = {
  res: T
  error: null
}

type Failure<E> = {
  res: null
  error: E
}

type Result<T, E = Error> = Success<T> | Failure<E>

// Main wrapper function
export async function tryCatch<T, E = Error>(
  promise: () => Promise<T>,
): Promise<Result<T, E>> {
  try {
    const res = await promise()
    return { res, error: null }
  } catch (error) {
    return { res: null, error: error as E }
  }
}
